import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";
import { getCategoryCount } from "@/lib/videos";

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-5">
      {categories.map((category) => (
        <Link
          key={category.id}
          to={`/category/${category.id}`}
          className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors duration-300 hover:border-primary-300 md:p-5"
        >
          <div className="flex items-start justify-between">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-50 text-primary-600 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${category.icon} text-xl`} />
            </span>
            <span className="font-label text-[11px] tracking-widest text-foreground-400">
              {String(getCategoryCount(category.id)).padStart(2, "0")}
            </span>
          </div>
          <div>
            <h3 className="text-[15px] font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
              {category.name}
            </h3>
            <p className="mt-1 text-xs text-foreground-500">{category.countLabel} · 共 {getCategoryCount(category.id)} 条收录</p>
          </div>
          <span className="mt-auto inline-flex items-center gap-1 text-xs text-primary-700 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            进入分类
            <i className="ri-arrow-right-line text-sm" />
          </span>
        </Link>
      ))}
    </div>
  );
}